import { LoadingSpinner } from '../../../../utils';
import { Stack } from '@mui/material';

const Loading = ({ isLoading }) => {
  if (!isLoading) return;
  
  return (
    <Stack alignItems="center" py={1}>
      <LoadingSpinner isLoading sx={{ top: null, left: null }} />
    </Stack>
  );
};


export default Loading;